/* eslint-disable no-dupe-keys */
import { Box, Typography, Button, Tooltip } from '@mui/material'
import React from 'react'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Data from './Data';
import OverTimePolicyPop from './OverTimePolicyPop';
const OverTimePage = () => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClickClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '30px' }}>
                        <Box>
                            <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                Overtime policies
                                <Tooltip title="Individuals who do not wish to receive these can unsubscribe at the bottom of the email" arrow placement="top" alignContent="center">
                                    <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                        <InfoOutlineIcon fontSize="small" />
                                    </button>
                                </Tooltip>
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Configure automated overtime rules</Typography>
                        </Box>
                        <Box>
                            <Button onClick={handleClickOpen} variant="contained" sx={{ boxShadow: 'none', width: '120px', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                                + Add Policy</Button>
                        </Box>
                    </Box>
                    <Data />
                </Box>
            </Box>
            <OverTimePolicyPop open={open}  handleClickClose={handleClickClose} />
        </>
    )
}
export default OverTimePage
